import "./style.scss";

const Default = ({ handleClick = () => {}, id = "", type = false, typeLabel = "", title = "", cover = "" }) => {
    return (
        <div className={`list-item ${type ? type : ""}`} id={id} onClick={handleClick}>
            <div className="list-item__logo">
                <img alt={`logo_desktop`} className={`logo_desktop`} src={cover} />
            </div>
            <div className="list-item__title-container">
                <span className={`list-item__title`} dangerouslySetInnerHTML={{ __html: title }}></span>
            </div>
            {type === "hit" ? <span className={`list-item__hit-label_block ${type}`}>{typeLabel}</span> : null}
            <button className="list-item__details-button" type="button">
                <span>Подробнее</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="m6 3 5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
        </div>
    );
};

export default Default;
